import { connect } from 'react-redux';
import Shipment from './Shipment';
import {
  getShipment,
  getShipmentActRemoveM15B,
  getShipmentErrorClear
} from '../../../store/actions/shipment';
import { modalErrorOpen } from '../../../store/actions/modalError';
import {
  modalSKZipOpen,
  modalProcessingStartOpen,
  modalShipmentRedeemConsignmentOpen,
  modalShipmentPlanReadyOpen,
  modalShipmentPlanCancelOpen,
  modalShipmentSZRebindingOpen
} from '../../../store/actions/modal';
import { getProcessingStartCancel, getProcessingStartClear } from '../../../store/actions/processing';

const mapStateToProps = ({
  settingsReducer,
  shipmentReducer,
  tabsReducer,
  userReducer
}) => ({
  settingsReducer,
  shipmentReducer,
  tabsReducer,
  userReducer
});
const mapDispatchToProps = {
  getShipment,
  getShipmentActRemoveM15B,
  modalErrorOpen,
  getShipmentErrorClear,
  modalSKZipOpen,
  modalProcessingStartOpen,
  getProcessingStartCancel,
  getProcessingStartClear,
  modalShipmentRedeemConsignmentOpen,
  modalShipmentPlanCancelOpen,
  modalShipmentPlanReadyOpen,
  modalShipmentSZRebindingOpen
};

const ShipmentRecycling = connect(
  mapStateToProps,
  mapDispatchToProps
)(Shipment);

export default ShipmentRecycling;
